module.exports = __webpack_public_path__ + "static/img/5.460f349.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/5.png
// module id = UU9U
// module chunks = 0